import Gems from "../../assets/Crafts/Marquise.png";
import Footer from "../Footer/footer";
import Header from "../Header/Header";
import "./Marquise.css";
const Marquise = () => {
  return (
    <>
      <Header />
      <div className="marquise">
        <div className="title">
          <div className="title-image">
            <img
              src={Gems}
              alt="icon1"
              style={{ height: "70px", width: "35px" }}
            />
            <h2>Marquise Diamond</h2>{" "}
          </div>
          <div className="title-text">
            &#x301D;Indulge in the allure of marquise diamonds, a symbol of
            elegance and sophistication. Each marquise diamond in our collection
            is meticulously crafted to showcase its unique elongated shape and
            exquisite brilliance. With its gracefully tapered ends and timeless
            appeal, the marquise diamond is perfect for those seeking a
            distinctive and stylish choice. Whether as a dazzling centerpiece in
            an engagement ring or as an eye-catching accent in a pendant,
            marquise diamonds add a touch of glamour to any jewelry piece.
            Explore our exquisite marquise diamond collection and discover the
            perfect symbol of love and beauty for your special moments.&#x301E;
          </div>
        </div>
        <div class="container">
          <div class="horizontal-line"></div>
        </div>
        <div className="sizes">
          <h2>Wide Range of Sizes</h2>
          Magnificent jewellery designs are enhanced by just the perfect size of
          diamonds. We provide one of the widest selections of sizes.
          <div className="size-list">
            <div className="size2">
              <img
                src={Gems}
                alt="icon1"
                style={{ height: "90px", width: "45px" }}
              />
              <p>0.01 - 0.03 cts</p>
            </div>
            <div className="size3">
              <img
                src={Gems}
                alt="icon1"
                style={{ height: "110px", width: "55px" }}
              />
              <p>0.03 - 0.07 cts</p>
            </div>
            <div className="size4">
              <img
                src={Gems}
                alt="icon1"
                style={{ height: "130px", width: "65px" }}
              />
              <p>0.07 - 0.18 cts</p>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="horizontal-line"></div>
        </div>
        <div className="color">
          <h2>Awesome Cuts & Color</h2>
          The greatest kind of value is added by a precisely cut diamond
          combined in a distinctive colour; our masterpieces add value that
          takes it to the next level.
          <svg
            _ngcontent-yvo-c198=""
            xmlns="http://www.w3.org/2000/svg"
            width="257"
            height="110"
            viewBox="0 0 257 110"
            fill="none"
          >
            <path
              _ngcontent-yvo-c198=""
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M201.917 0C201.782 0.000192415 201.647 0.00087047 201.512 0.0020325L187.697 13.8177L202.148 19.7477L217.204 13.5236L201.917 0ZM218.427 11.9347L221.825 3.68222C216.568 1.65004 210.922 0.402146 205.028 0.082048L218.427 11.9347ZM182.177 3.67911C187.317 1.69293 192.83 0.456591 198.582 0.104239L186.125 12.5612L182.177 3.67911ZM217.03 94.1911L202.001 109.22L187.97 94.02L202.238 88.1216L217.03 94.1911ZM222.381 106.105C216.689 108.378 210.527 109.727 204.082 109.967L218.399 95.6504L222.381 106.105ZM224.226 105.329C229.681 102.916 234.671 99.6413 239.022 95.6784L220.15 94.6299L224.226 105.329ZM220.477 92.645L240.798 93.774L240.236 72.4132L226.439 78.1171L220.477 92.645ZM252.88 75.9271C250.439 81.8565 246.992 87.2655 242.751 91.9415L242.217 71.6621L252.88 75.9271ZM243.005 69.8231L253.607 74.064C255.65 68.5341 256.83 62.5858 256.983 56.3828L243.005 69.8231ZM240.762 69.7263L240.87 69.987L227.508 75.5109L235.302 56.5172L240.608 69.3531L240.502 69.4553L240.762 69.7263ZM242.157 67.8641L236.38 53.8899L242.012 40.1644L256.204 54.3568L242.157 67.8641ZM242.863 38.0897L242.835 38.1589L256.932 52.2564C256.617 45.8489 255.206 39.7297 252.881 34.0824L242.863 38.0897ZM240.663 38.184L235.295 51.2655L227.451 32.2922L240.437 37.6208L240.663 38.184ZM240.827 35.6188L226.375 29.6887L220.285 14.9579L240.253 15.4833C240.446 15.6698 240.637 15.8578 240.827 16.0471V35.6188ZM242.827 35.9502L252.086 32.2464C249.729 27.0672 246.593 22.3178 242.827 18.1481V35.9502ZM223.677 4.43745L220.17 12.9541L238.005 13.4234C233.75 9.73573 228.924 6.69015 223.677 4.43745ZM183.765 15.5736L163.167 16.1457L163.167 35.8624L177.947 29.7524L183.765 15.5736ZM165.237 14.0875C169.673 10.0987 174.762 6.82122 180.324 4.43443L184.378 13.5558L165.237 14.0875ZM161.167 18.1476L161.167 35.9629L152.003 32.0376C154.349 26.9394 157.452 22.2614 161.167 18.1476ZM164.182 37.6069L163.785 38.5342L169.084 51.3522L176.878 32.3587L164.182 37.6069ZM160.873 38.0127L151.2 33.8696C148.949 39.2747 147.535 45.1161 147.121 51.2317L160.873 38.0127ZM150.468 74.2841C148.313 68.5274 147.095 62.3131 147 55.8269L160.778 70.1605L150.468 74.2841ZM168.006 53.9794L162.02 68.5669L147.59 53.555L162.075 39.6319L168.006 53.9794ZM184.185 94.5682L179.78 105.334C173.818 102.699 168.413 99.0353 163.788 94.5682H184.185ZM186.541 92.4466L185.977 92.216L180.617 79.2497L199.611 87.0435L186.541 92.4466ZM186.164 95.0122L181.624 106.109C187.331 108.386 193.508 109.735 199.97 109.969L186.164 95.0122ZM178.01 78.1802L183.958 92.5682H163.167L163.167 72.0895L178.01 78.1802ZM161.167 91.8581L161.167 72.1588L151.204 76.1441C153.624 81.9533 157.013 87.2584 161.167 91.8581ZM180.551 28.6761L199.524 20.8326L186.039 15.2994L180.551 28.6761ZM176.934 75.5768L169.091 56.6039L163.558 70.088L176.934 75.5768ZM223.835 79.1934L204.862 87.0367L218.346 92.5696L223.835 79.1934ZM223.769 28.6193L218.245 15.2575L204.776 20.8257L223.769 28.6193Z"
              fill="#253646"
            ></path>
            <path
              _ngcontent-yvo-c198=""
              d="M45.2097 54.0008C45.1168 53.8832 42.888 51.0872 39.0669 48.2799C33.9608 44.5285 28.4049 42.5456 22.9998 42.5456C17.595 42.5456 12.0391 44.5285 6.9328 48.2799C3.11178 51.0871 0.882952 53.8832 0.790004 54.0008L0 55L0.790105 55.9992C0.883053 56.1169 3.11188 58.9129 6.9329 61.7202C12.0392 65.4715 17.5951 67.4544 22.9999 67.4544C28.4049 67.4544 33.9608 65.4715 39.0669 61.7202C42.888 58.9129 45.1168 56.1169 45.2097 55.9992L46 55L45.2097 54.0008ZM22.9998 63.725C18.1889 63.725 14.2749 59.811 14.2749 55C14.2749 54.2462 14.3709 53.5145 14.5515 52.8164L12.5595 52.4811C12.3643 53.2892 12.2608 54.1327 12.2608 55C12.2608 58.1076 13.5883 60.9108 15.7052 62.8735C12.9801 61.8669 10.6629 60.4544 8.91401 59.1769C6.74731 57.5943 5.1235 55.9938 4.19775 55C5.1239 54.0058 6.74751 52.4055 8.91401 50.8231C10.6629 49.5456 12.9802 48.133 15.7052 47.1263L17.0415 48.6326C18.6022 47.1712 20.6982 46.275 22.9998 46.275C27.8108 46.275 31.7247 50.1889 31.7247 55C31.7247 59.811 27.8108 63.725 22.9998 63.725ZM37.0857 59.1769C35.3366 60.4544 33.0195 61.8669 30.2945 62.8735C32.4113 60.9109 33.7388 58.1077 33.7388 54.9999C33.7388 51.892 32.4113 49.089 30.2945 47.1262C33.0196 48.1329 35.3366 49.5455 37.0857 50.823C39.2524 52.4055 40.8762 54.006 41.8019 54.9998C40.8758 55.9941 39.2522 57.5945 37.0857 59.1769Z"
              fill="black"
            ></path>
            <path
              _ngcontent-yvo-c198=""
              d="M17.4478 53.304C17.284 53.8406 17.1953 54.4099 17.1953 55.0001C17.1953 58.2058 19.7941 60.8047 23 60.8047C26.2057 60.8047 28.8045 58.2059 28.8045 55.0001C28.8045 51.7942 26.2057 49.1954 23 49.1954C21.4385 49.1954 20.0221 49.8131 18.9787 50.8161L21.8419 54.0434L17.4478 53.304Z"
              fill="black"
            ></path>
            <line
              _ngcontent-yvo-c198=""
              x1="24.1611"
              y1="54.6853"
              x2="181.685"
              y2="3.83888"
              stroke="#253646"
              stroke-width="0.5"
              stroke-linecap="square"
              stroke-dasharray="2 5"
            ></line>
            <line
              _ngcontent-yvo-c198=""
              x1="24.3134"
              y1="56.8364"
              x2="179.836"
              y2="105.687"
              stroke="#253646"
              stroke-width="0.5"
              stroke-linecap="square"
              stroke-dasharray="2 5"
            ></line>
          </svg>
        </div>
        <div class="container">
          <div class="horizontal-line"></div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Marquise;
